module.exports = __webpack_public_path__ + "static/media/mentor_business.589dbc01.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/mentor_business.jpg
// module id = 400
// module chunks = 0